import Apis from 'apis';

export const api = Apis({});

export default {
  login: () => `/authenticate/`,
  mfa: () => `/authenticate/mfa/`,
  resetPassword: () => '/authenticate/password/reset/',
  update: () => '/authenticate/password/set/',
  checkRestrictions: () => '/authenticate/password/policy/operator/',
  trustedLogin: () => '/authenticate/oneplatform/',
  logout: () => '/authenticate/logout/',
};
